<template>
    <LayoutSub>
        <SubSection class="pb-0" v-if="data">
            <ProductList :postData="data" />
        </SubSection>
    </LayoutSub>
</template>
<script>
import SubSection from '@/components/SubSection.vue';
import LayoutSub from '@/layouts/LayoutSub.vue';
import ProductList from './common/ProductList.vue';
import { getProduct } from '@/api';

export default {
    components: {
        LayoutSub,
        SubSection,
        ProductList,
    },
    data() {
        return {
            data: null,
        };
    },
    async mounted() {
        const result = await getProduct('kiosk', this.$route.query);
        this.data = result.data.paging;
    },
    watch:{
    async $route(){
      const result = await getProduct('kiosk', this.$route.query);
      this.data = result.data.paging;
    }
  }
};
</script>
